<template>
  <b-overlay
    :show="!dataIsReady"
    spinner-type="border"
    variant="light"
    spinner-variant="primary"
    opacity="1"
    rounded>
    <failed-data-get
      v-if="failedGetResellerStatus || failedIntegrationGetStatus"
      text="Looks like this reseller doesn't exist." />

    <template v-else>
      <div class="d-flex align-items-end pt-2 pb-6">
        <div class="d-flex flex-column">
          <h1 class="h5 mb-2">
            Reseller Integrations
          </h1>
          <b-breadcrumb class="breadcrumb-transparent breadcrumb-line p-0 m-0">
            <b-breadcrumb-item :to="{ name: 'Dashboard' }">
              <i class="fa fa-home fa-sm mr-2"></i>
              Home
            </b-breadcrumb-item>
            <b-breadcrumb-item :to="{ name: 'ResellersList' }">Resellers</b-breadcrumb-item>
            <b-breadcrumb-item active>Intergations</b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>

      <b-row>
        <b-col
          xl="9"
          class="pr-4 pr-xl-16">
          <b-row>
            <b-col
              v-for="integration in integrationsList"
              :key="`integration-${integration.slug}`"
              cols="12"
              md="6"
              lg="4"
              class="d-flex">
              <b-card
                class="card-custom card-border card-hoverable mb-4 mb-sm-6 flex-grow-1"
                body-class="d-flex flex-column align-items-start">
                <b-badge
                  :variant="integration.enabled ? 'light-success' : 'light'"
                  class="position-absolute top-7 right-7 font-size-xs d-flex align-items-center">
                  <i
                    :class="integration.enabled ? 'label-success' : 'label-dark opacity-40'"
                    class="label label-dot mr-1"></i>
                  <span :class="integration.enabled ? 'text-success' : 'text-muted'">
                    {{ integration.enabled ? 'Enabled' : 'Disabled' }}
                  </span>
                </b-badge>
                <span class="d-inline-block svg-icon svg-icon-xl w-30px h-30px mb-4">
                  <inline-svg
                    :src="`media/svg/icons/Integrations/${integration.slug}.svg`"
                    class="svg-icon m-0" />
                </span>
                <div class="font-size-lg font-weight-bolder mb-4">
                  {{ integration.name }}
                </div>
                <p class="font-size-sm mb-6">
                  {{ integration.description }}
                </p>
                <router-link
                  :to="`/resellers/${routeId}/integrations/${integration.slug}`"
                  custom
                  v-slot="{ navigate }">
                  <b-button
                    v-wave
                    role="link"
                    size="sm"
                    variant="outline-primary"
                    class="mt-auto"
                    @click="navigate">
                    <span>Setup integration</span>
                  </b-button>
                </router-link>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
        <b-col xl="3">
          <b-card
            class="card-custom card-border"
            body-class="pb-4">
            <reseller-details-plate :flush="true" />
          </b-card>
        </b-col>
      </b-row>
    </template>
  </b-overlay>
</template>

<script>
import {
  // actions
  GET_RESELLER,
  
  // mutations
  SELECT_RESELLER,
  UNSELECT_RESELLER
} from '@/core/services/store/resellers.module'
import { GET_INTEGRATIONS } from '@/core/services/store/integrations.module'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'
import { showToast } from '@/core/utils'
import ResellerDetailsPlate from './components/ResellerDetailsPlate.vue'

export default {
  name: 'ResellerIntegrations',
  components: {
    ResellerDetailsPlate
  },
  data() {
    return {
      dataIsReady: false,

      showToast
    }
  },
  computed: {
    ...mapGetters([
      'integrationsList',
      'failedGetResellerStatus',
      'failedIntegrationGetStatus',
      'integrationsResponses'
    ]),

    routeId() {
      return this.$route.params.id
    }
  },
  watch: {
    /* eslint-disable-next-line no-unused-vars */
    routeId(newVal, oldVal) {
      if (newVal) {
        this.dataIsReady = false
        this.$store.commit(UNSELECT_RESELLER)
        this.getReseller(newVal)
      }
    },
  },
  created() {
    this.getReseller(this.routeId)

    eventBus.$on('showToast/ResellerIntegrations', ({ message, variant }) => {
      this.showToast(message, variant)
    })
  },
  beforeDestroy() {
    this.dataIsReady = false
  },
  methods: {
    getReseller(id) {
      this.$store
        .dispatch(GET_RESELLER, { id })
        .then(data => {
          this.selectReseller(data)
        })
        .finally(() => {
          this.getIntegrations(id)
        })
    },

    getIntegrations(id) {
      this.$store
        .dispatch(GET_INTEGRATIONS, { id })
        .finally(() => { this.dataIsReady = true })
    },

    selectReseller(reseller) {
      this.$store.commit(SELECT_RESELLER, reseller)
    },
  }
}
</script>
